// District detection utility for Paris design districts
const DISTRICTS = {
  'Rive Gauche': {
    keywords: ['rive gauche', 'saint-germain', 'montparnasse', '75006', '75007', '75014', '75015', 
               'boulevard saint-germain', 'rue de sèvres', 'rue du bac', 'rue de rennes', 
               'boulevard raspail', 'boulevard montparnasse', 'rue de babylone', 'rue du cherche-midi',
               'rue de grenelle', 'rue saint-dominique', 'rue de varenne', 'invalides'],
    color: '#E63E6D',
    displayName: 'RIVE GAUCHE',
    shortName: 'RG'
  },
  'Palais-Royal / Place des Victoires / Pigalle': {
    keywords: ['palais-royal', 'place des victoires', 'pigalle', '75001', '75002', '75009', 
               'rue saint-honoré', 'rue montmartre', 'rue étienne marcel', 'boulevard de clichy',
               'rue de rivoli', 'rue du louvre', 'avenue de l\'opéra', 'place vendôme',
               'rue de la paix', 'rue du faubourg saint-honoré', 'madeleine', 'opéra'],
    color: '#4A90E2',
    displayName: 'PALAIS-ROYAL / PLACE DES VICTOIRES / PIGALLE',
    shortName: 'PR/PV/P'
  },
  'Marais / Bastille / République': {
    keywords: ['marais', 'bastille', 'république', '75003', '75004', '75011', 
               'rue de bretagne', 'rue vieille du temple', 'rue de turenne', 'place des vosges',
               'boulevard beaumarchais', 'rue oberkampf', 'rue de la roquette', 'rue saint-antoine',
               'rue du temple', 'rue des francs-bourgeois', 'rue charlot', 'rue de saintonge'],
    color: '#50C878',
    displayName: 'MARAIS / BASTILLE / RÉPUBLIQUE',
    shortName: 'M/B/R'
  },
  'Opéra / Concorde / Etoile': {
    keywords: ['opéra', 'concorde', 'étoile', 'etoile', '75008', '75001', '75009',
               'place de la concorde', 'place vendôme', 'champs-élysées', 'arc de triomphe',
               'avenue des champs-élysées', 'rue saint-honoré', 'rue de la paix', 
               'boulevard haussmann', 'rue de rivoli', 'place de l\'opéra', 'grands boulevards',
               'rue du faubourg saint-honoré', 'avenue montaigne', 'rue royale'],
    color: '#FF6B35',
    displayName: 'OPÉRA / CONCORDE / ETOILE',
    shortName: 'O/C/E'
  }
};

// Function to detect district from address
export const detectDistrict = (address) => {
  if (!address) return null;
  
  const normalizedAddress = address.toLowerCase();
  
  for (const [districtName, districtInfo] of Object.entries(DISTRICTS)) {
    for (const keyword of districtInfo.keywords) {
      if (normalizedAddress.includes(keyword)) {
        return {
          name: districtName,
          color: districtInfo.color,
          displayName: districtInfo.displayName,
          shortName: districtInfo.shortName
        };
      }
    }
  }
  
  return null;
};

// Function to get all districts for filter options
export const getAllDistricts = () => {
  return Object.keys(DISTRICTS).map(name => ({
    name,
    color: DISTRICTS[name].color,
    displayName: DISTRICTS[name].displayName,
    shortName: DISTRICTS[name].shortName
  }));
};

// Function to check if a property belongs to a district
export const propertyBelongsToDistrict = (properties, districtName) => {
  if (!properties) return false;
  
  // First check if district is explicitly set in the properties
  if (properties.district) {
    return properties.district === districtName;
  }
  
  // Otherwise detect from address
  if (!properties.adresse) return false;
  const detectedDistrict = detectDistrict(properties.adresse);
  return detectedDistrict && detectedDistrict.name === districtName;
};